import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const reviewApiService = createApi({
    reducerPath: 'reviewsApi',
    baseQuery: createNeighborhoodAwareBaseQuery('/review/'),
    endpoints: (builder) => ({
        getReviews: builder.query({
            query: (args) => {
                let { id } = args

                if (id) {
                    return `get/${id}`
                }

                let query = queryParams(args)

                return `get${query}`
            },
            keepUnusedDataFor: 0
        }),
        updateReview: builder.mutation({
            query: (body) => ({
                url: `update/${body?._id}`,
                method: "PUT",
                body
            })
        })
    })
})

export const {
    useGetReviewsQuery,
    useUpdateReviewMutation
} = reviewApiService
